import { Status } from "../types";

type TranslationMap = {
  [key: string]: string | TranslationMap;
};

type LocaleTranslations = {
  [locale: string]: {
    [key: string]: string | TranslationMap;
  };
};

const translations: LocaleTranslations = {
  en: {
    status: {
      [Status.ACTIVE]: "Active",
      [Status.INACTIVE]: "Not in Operation",
      [Status.ON_HOLD]: "On Hold",
      [Status.OUT_LATE]: "Out Late",
      [Status.CLOSED_TEMPORARILY]: "Closed Today",
      [Status.CLOSED_SEASONALLY]: "Closed Seasonally",
      [Status.CLOSED_PERMANENTLY]: "Closed Permanently"
    }
  }
};

export default translations;
